










































































































































































































































































































































































































































































































































import _ from "lodash";
import "devextreme/dist/css/dx.light.css";
import { Component, Vue, Prop } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { Maintenancejob, Property, Fee } from "@/models";
import DatesTab from "@/pages/jobs/tabs/Dates.vue";
import "devextreme/dist/css/dx.light.css";
import { DxDateBox } from "devextreme-vue/date-box";

@Component({
  components: {
    DatesTab,
    DxDateBox
  }
})
export default class Quotation extends Vue {
  @Prop({ default: false }) public showsidebar: boolean;
  @Getter("maintenancejobs/current") public maintenancejob: Maintenancejob;
  @Getter("maintenancejob/list") public list: Property[];
  @Mutation("maintenancejobs/setCurrent")
  public setCurrent: (maintenancejob: Maintenancejob) => void;
  @Action("maintenancejobs/getMaintenancejob")
  public getMaintenancejob: (id: string) => Promise<Maintenancejob>;
  @Action("maintenancejobs/setMaintenancejobDeep")
  public setMaintenancejobDeep: (payload: {
    path: string;
    data: any;
  }) => Promise<any>;
  @Mutation("maintenancejobs/addUnsavedChange")
  public addUnsavedChange: (id: string) => Promise<any>;

  public async mounted() {
    setTimeout(() => {
      if (this.materials.length === 0) {
        this.setMaintenancejobDeep({
          path: "quotation.material",
          data: [new Fee()]
        });
      }
      if (this.labours.length === 0) {
        this.setMaintenancejobDeep({
          path: "quotation.labour",
          data: [new Fee()]
        });
      }
      if (this.mics.length === 0) {
        this.setMaintenancejobDeep({
          path: "quotation.mics",
          data: [new Fee()]
        });
      }
      this.allCalculation();
    }, 1000);
  }
  get doq() {
    return this.maintenancejob.quotation.doq;
  }
  set doq(data) {
    this.setMaintenancejobDeep({ path: "quotation.doq", data });
  }
  get ref() {
    return this.maintenancejob.quotation.ref;
  }
  set ref(data) {
    this.setMaintenancejobDeep({ path: "quotation.ref", data });
  }
  get startdate() {
    return this.maintenancejob.quotation.doq;
  }
  set startdate(data) {
    this.setMaintenancejobDeep({ path: "quotation.startdate", data });
  }
  get enddate() {
    return this.maintenancejob.quotation.enddate;
  }
  set enddate(data) {
    this.setMaintenancejobDeep({ path: "quotation.enddate", data });
  }
  get validuntil() {
    return this.maintenancejob.quotation.validuntil;
  }
  set validuntil(data) {
    this.setMaintenancejobDeep({ path: "quotation.validuntil", data });
  }

  get description() {
    return this.maintenancejob.quotation.description;
  }
  set description(data) {
    this.setMaintenancejobDeep({ path: "quotation.description", data });
  }
  get discount() {
    return this.maintenancejob.quotation.discount;
  }
  set discount(data) {
    this.setMaintenancejobDeep({ path: "quotation.discount", data });
  }
  get taxrate() {
    return this.maintenancejob.quotation.taxrate;
  }
  set taxrate(data) {
    this.setMaintenancejobDeep({ path: "quotation.taxrate", data });
  }

  get materials() {
    return this.maintenancejob.quotation.material;
  }
  set materials(data: Fee[]) {
    this.setMaintenancejobDeep({
      path: "quotation.material",
      data
    });
  }

  public addNewMaterial(): void {
    this.maintenancejob.quotation.material = this.maintenancejob.quotation.material.concat(
      [new Fee()]
    );
  }

  public deletematerialindex: number = -1;
  public showDeleteDialog(index: number) {
    this.deletematerialindex = index;
    this.removeMaterial();
  }
  public removeMaterial(): void {
    this.maintenancejob.quotation.material = this.$onecentral.removeItemByIndex(
      this.maintenancejob.quotation.material,
      this.deletematerialindex
    );
  }

  get labours() {
    return this.maintenancejob.quotation.labour;
  }
  set labours(data: Fee[]) {
    this.setMaintenancejobDeep({
      path: "quotation.labour",
      data
    });
  }

  public addNewLabour(): void {
    this.maintenancejob.quotation.labour = this.maintenancejob.quotation.labour.concat(
      [new Fee()]
    );
  }

  public deletelabourindex: number = -1;
  public showDeleteLabourDialog(index: number) {
    this.deletelabourindex = index;
    this.removeLabour();
  }
  public removeLabour(): void {
    this.maintenancejob.quotation.labour = this.$onecentral.removeItemByIndex(
      this.maintenancejob.quotation.labour,
      this.deletelabourindex
    );
  }

  get mics() {
    return this.maintenancejob.quotation.mics;
  }
  set mics(data: Fee[]) {
    this.setMaintenancejobDeep({
      path: "quotation.mics",
      data
    });
  }

  public addNewMics(): void {
    this.maintenancejob.quotation.mics = this.maintenancejob.quotation.mics.concat(
      [new Fee()]
    );
  }

  public deletemicsindex: number = -1;
  public showDeleteMicsDialog(index: number) {
    this.deletemicsindex = index;
    this.removeMics();
  }
  public removeMics(): void {
    this.maintenancejob.quotation.mics = this.$onecentral.removeItemByIndex(
      this.maintenancejob.quotation.mics,
      this.deletemicsindex
    );
  }

  isNumber(event: any) {
    const keyCode = event.keyCode || event.which;
    const inputChar = String.fromCharCode(keyCode);

    if (!/^\d*\.?\d{0,2}$/.test(event.target.value + inputChar)) {
      event.preventDefault();
    }
  }

  calculateTotal(fee: Fee, type: string, index: number) {
    // Parse rate and qty as numbers
    const parsedQty = parseFloat(fee.qty) || 0;
    const parsedRate = parseFloat(fee.unitprice) || 0;

    // Calculate the total
    let total = (parsedRate * parsedQty).toFixed(2);
    this.setMaintenancejobDeep({
      path: `quotation.${type}[${index}].amount`,
      data: total.toString()
    });
  }

  async onPaste(event: any) {
    // Prevent pasting non-numeric values
    event.preventDefault();

    try {
      const clipboardData = await navigator.clipboard.readText();

      if (!/^\d*\.?\d{0,2}$/.test(clipboardData)) {
        // You can add your handling logic here (e.g., show an error message)
      } else {
        // Replace the input value with the pasted data
        event.target.value = clipboardData;
      }
    } catch (error) {
      console.error("Failed to read clipboard data:", error);
    }
  }

  // In your component or service:
  public totalByType(type: string) {
    if (this.maintenancejob.quotation.hasOwnProperty(type)) {
      let res: Fee[] =
        type == "material"
          ? this.maintenancejob.quotation.material
          : type == "labour"
          ? this.maintenancejob.quotation.labour
          : this.maintenancejob.quotation.mics;
      const grandTotal = res.reduce((accumulator, currentItem) => {
        if (currentItem.unitprice && currentItem.qty) {
          // Calculate the total for the current item (rate * qty)
          const itemTotal =
            parseFloat(currentItem.unitprice) * parseFloat(currentItem.qty);

          // Add the current item's total to the accumulator
          return accumulator + itemTotal;
        } else {
          return accumulator;
        }
      }, 0); // 0 is the initial accumulator value
      return Number.isNaN(grandTotal) ? 0 : grandTotal.toFixed(2);
    } else {
      // Handle the case where the type is not found in quotation
      return 0; // or return an appropriate value
    }
  }
  public subTotal: number = 0;
  public subTotalLessDiscount: number = 0;
  public totalTax: number = 0;
  public mainTotal: number = 0;
  public async allCalculation() {
    this.subTotal = 0; // Initialize subTotal to 0
    let typeArray = ["material", "labour", "mics"];
    for (let type of typeArray) {
      let output = this.totalByType(type);
      this.subTotal += +output;
    }
    let discount =
      this.maintenancejob.quotation.discount == ""
        ? 0
        : parseFloat(this.maintenancejob.quotation.discount);
    this.subTotalLessDiscount = this.subTotal - discount;
    let taxpercent =
      this.maintenancejob.quotation.taxrate == ""
        ? 0
        : +this.maintenancejob.quotation.taxrate;

    this.totalTax = (this.subTotalLessDiscount * taxpercent) / 100;
    this.mainTotal = this.subTotalLessDiscount + this.totalTax;
  }
  get approvetoggle() {
    return this.maintenancejob.quotation.approvetoggle;
  }
  set approvetoggle(data) {
    this.setMaintenancejobDeep({ path: "quotation.approvetoggle", data });
  }

  public setBooleanValue(val: boolean) {
    this.setMaintenancejobDeep({ path: "quotation.approvetoggle", data: val });
  }
}
